import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from './api';
import { internationalTours, indiaTours } from './mock';

// ---------- Site Settings ----------
const DEFAULT_SETTINGS = {
  hero_heading: 'Explore, Discover, Enjoy',
  hero_subheading: '',
  tagline: 'journeys, redefined...',
  phone: '+91-9650336344',
  email: 'info@travelsera.com',
  address: '401, Spaze IT Park, Gurgaon, Haryana (India)',
  whatsapp: '919650336344',
  footer_about: '',
  section_bestsellers_title: 'Bestsellers',
  section_themes_title: 'Explore Destinations by Theme',
  section_countries_title: 'Top Trending Countries',
  section_states_title: 'Trending Indian States',
  section_india_title: 'India Tour Packages',
  section_testimonials_title: 'What Our Travellers Say',
  section_partners_title: 'Our Trusted Hotel Partners',
  section_blog_title: 'Guides & Stories',
  hero_chips_domestic: ['Darjeeling', 'Goa', 'Andaman', 'Himachal', 'Kashmir', 'Kerala', 'Rajasthan', 'Sikkim'],
  hero_chips_international: ['Bhutan', 'Indonesia', 'Malaysia', 'Maldives', 'Singapore', 'Thailand', 'Vietnam'],
  benefit_1_title: '18+ years of Experience',
  benefit_1_desc: 'With the best professionals in the industry, you are in safe hands!',
  benefit_1_icon: 'Award',
  benefit_2_title: '500+ Destinations',
  benefit_2_desc: 'From Sikkim & Darjeeling to Thailand and Singapore\u2014crafted journeys that inspire you to travel more and discover endlessly.',
  benefit_2_icon: 'Globe2',
  benefit_3_title: 'Best Price In The Industry',
  benefit_3_desc: 'Cheapest price is not the best price. We prefer to provide best quality services at best price.',
  benefit_3_icon: 'BadgeIndianRupee',
};

const SettingsContext = createContext(DEFAULT_SETTINGS);
export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    axios.get(`${API}/site-settings`)
      .then((res) => {
        if (res.data) setSettings((prev) => ({ ...prev, ...res.data }));
      })
      .catch(() => {});
  }, []);
  // Apply the admin-uploaded favicon at runtime — takes effect immediately
  // after the admin saves; no redeploy needed.
  useEffect(() => {
    const url = (settings.favicon_url || '').trim();
    if (!url) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = url;
  }, [settings.favicon_url]);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

// ---------- Packages ----------
const mockAll = [
  ...internationalTours.map((p) => ({ ...p, pkg_code: p.id, category: 'international' })),
  ...indiaTours.map((p) => ({ ...p, pkg_code: p.id, category: 'india' })),
];

const PackagesContext = createContext({ packages: mockAll, loading: true });
export const usePackages = () => useContext(PackagesContext);

export const PackagesProvider = ({ children }) => {
  const [packages, setPackages] = useState(mockAll);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/packages`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          // normalize: expose `id` for existing components that used mock ids
          setPackages(res.data.map((p) => ({ ...p, id: p.pkg_code })));
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <PackagesContext.Provider value={{ packages, loading }}>
      {children}
    </PackagesContext.Provider>
  );
};

export const getInternational = (packages) => packages.filter((p) => (p.category || 'international') !== 'india');
export const getIndia = (packages) => packages.filter((p) => (p.category || 'international') === 'india');
